import { render } from "./SecondaryTabbar.vue?vue&type=template&id=2a0b389e&scoped=true"
import script from "./SecondaryTabbar.vue?vue&type=script&lang=js"
export * from "./SecondaryTabbar.vue?vue&type=script&lang=js"

import "./SecondaryTabbar.vue?vue&type=style&index=0&id=2a0b389e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0b389e"]])

export default __exports__